"use client";

import { useTranslations } from "@repo/internationalization";

type ErrorPageProps = { error: Error & { digest?: string }; reset: () => void };

export default function ErrorPage({ reset }: ErrorPageProps) {
  const t = useTranslations("Common.error");
  return (
    <div className="mx-auto flex max-w-5xl flex-col items-center justify-center px-6 py-16 text-center">
      <div role="alert">
        <h1 className="text-4xl font-semibold tracking-tight">{t("title")}</h1>
        <p className="mt-4 text-muted-foreground">{t("description")}</p>
      </div>
      <button
        className="mt-8 inline-flex h-10 items-center rounded-md bg-primary px-5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        onClick={reset}
        type="button"
      >
        {t("retry")}
      </button>
    </div>
  );
}
